"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSession = exports.SessionConsumer = exports.SessionContext = exports.SessionProvider = void 0;

var _Session = _interopRequireDefault(require("@arcblock/did-react/lib/Session"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable object-curly-newline */


var _ref = (0, _Session["default"])('did.playground.token'),
    SessionProvider = _ref.SessionProvider,
    SessionContext = _ref.SessionContext,
    SessionConsumer = _ref.SessionConsumer,
    withSession = _ref.withSession;

exports.withSession = withSession;
exports.SessionConsumer = SessionConsumer;
exports.SessionContext = SessionContext;
exports.SessionProvider = SessionProvider;